<mat-drawer-container class="main-content">
  <mat-drawer mode="side" opened *ngIf="checkLoginStatus">
    <app-nav></app-nav>
  </mat-drawer>
  <mat-drawer-content class="content">
    <app-drop-down></app-drop-down>
    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>